import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/axiosAuth";

export const fetchWHProducts = createAsyncThunk(
  "api/WHProducts/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`/api/WHProducts`);
      return { rows: response.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const WHProductsSlice = createSlice({
  name: "WHProducts",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWHProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWHProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
      })
      .addCase(fetchWHProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default WHProductsSlice.reducer;
export const selectWHProductsRows = (state) => state.WHProducts.rows;
export const selectWHProductsStatus = (state) => state.WHProducts.status;
export const selectWHProductsError = (state) => state.WHProducts.error;
